function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { styleguide, lightThemeObject } from "../../styleguide";

var Text = function Text(_ref) {
  var children = _ref.children,
      style = _ref.style;
  return /*#__PURE__*/React.createElement("span", {
    style: _objectSpread(_objectSpread({}, {
      color: "var(--bui-text, ".concat(lightThemeObject['--bui-text'], ")"),
      fontSize: styleguide.font.size.small,
      fontFamily: styleguide.font.family.regular
    }), style)
  }, children);
};

Text.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element, PropTypes.string, PropTypes.number]),

  /**
   * Overrides or extends default style settings.
   */
  style: PropTypes.object
} : {};
export default Text;
//# sourceMappingURL=Text.js.map